<!-- @format -->
<template>
    <div v-cloak class="revoke-reason-widget" :class="{ error: getIsValidField() }">
        <div class="widget-contents-container">
            <div class="widget-header">
                <h3>Reason for revoke</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <h2 class="label-config" :class="{ 'has-errors': getIsValidField() }">
                    The contact will receive an email with the reason for denial.
                </h2>
                <div class="gray-container" :class="{ 'has-errors': getIsValidField() }">
                    <div class="custom-textarea">
                        <textarea
                            id="text-area"
                            v-model="denyReason"
                            class="text-area"
                            cols="30"
                            rows="6"
                            placeholder="What is your reason for revoking this request"
                        ></textarea>
                    </div>
                </div>
                <div class="error-message">Required</div>
            </div>
            <div class="widget-footer">
                <div class="action-container">
                    <app-button :disabled="isLoading" class="cancel-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                    <div class="rigth-buttons">
                        <app-button class="accept-btn" :loading="isLoading" @click="onClickSave">
                            Save and send
                        </app-button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import EventBus from '@/scripts/event-bus';
const AppButton = () => import('@/components/common/app-button');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg');
import { StorefrontService } from '@/scripts/services/storefront/StorefrontService';
import { required } from 'vuelidate/lib/validators';

export default {
    name: 'revoke-reason-widget',

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
    },

    props: {
        widget: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            denyReason: '',
            isLoading: false,
        };
    },

    computed: {},

    validations() {
        return {
            denyReason: {
                required,
            },
        };
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        onClickSave() {
            this.$v.$touch();
            if (this.$v.$invalid) {
                return;
            }

            this.isLoading = true;
            StorefrontService.revoke(this.widget.agencyId, { reason: this.denyReason })
                .then(() => {
                    EventBus.$emit('storefront:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.$helpers.showFailNotification(
                        'An error occurred while sending your request.',
                        { error },
                    );
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },

        getIsValidField() {
            const isValid = this.$v.denyReason.$invalid && this.$v.denyReason.$dirty;
            return isValid;
        },
    },
};
</script>

<style>
.revoke-reason-widget .gray-container {
    background: #fafafa;
    font: normal 16px/1em 'Roboto';
    width: 100%;
    border: 2px solid #cac6cb;
    padding: 7px 15px;
    border-radius: 20px;
    color: #382153;
}

.revoke-reason-widget .error-message {
    font: normal normal normal 12px/14px Roboto;
    letter-spacing: 0px;
    color: #877d88;
    display: block;
    margin: 0.3em 0 1.25em 0;
}

.revoke-reason-widget.error .error-message {
    color: #f30070;
}

.revoke-reason-widget textarea:focus {
    outline: none;
}

.revoke-reason-widget .gray-container.has-errors {
    border: 2px solid #f30070;
}

.revoke-reason-widget .custom-textarea {
    display: flex;
    flex-direction: column;
    font-weight: 400;
    gap: 2px;
    font: normal 16px/1em 'Roboto';
    width: 100%;
}

.revoke-reason-widget .text-area {
    resize: none;
    color: #382153;
}

.revoke-reason-widget .text-area::placeholder {
    color: #cac6cb;
}

.revoke-reason-widget .inline-flex {
    display: inline-flex;
    gap: 10px;
    align-items: center;
}

.revoke-reason-widget .cancel-btn {
    border: 1px solid #cac6cb;
    border-radius: 20px;
    background: transparent;
    font: normal normal medium 14px/25px Roboto;
    letter-spacing: 0px;
    color: #382153;
    width: 127px !important;
    height: 40px !important;
}

.revoke-reason-widget .cancel-btn:hover {
    background: #dcdcdc;
    border: 2px solid #cac6cb;
}

.revoke-reason-widget .rigth-buttons {
    display: flex;
    gap: 10px;
}

.revoke-reason-widget .label-config {
    margin-top: 0;
}

.revoke-reason-widget {
    font: normal normal normal 16px/20px Roboto;
    letter-spacing: 0px;
    color: #382153;
}

.revoke-reason-widget h2 {
    font: normal bold 16px/24px Roboto;
    letter-spacing: 0px;
    margin-top: 25px;
}

.revoke-reason-widget.error h2 {
    color: #f30070;
}

.revoke-reason-widget a {
    font: normal normal normal 16px/11px Roboto;
    letter-spacing: 0px;
    color: #18aeff;
}

.revoke-reason-widget.widget .widget-header {
    background: rgb(80, 82, 254);
    background: linear-gradient(90deg, rgba(80, 82, 254, 1) 0%, rgba(75, 201, 254, 1) 100%);
}

.revoke-reason-widget .action-container {
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
